import styled from 'styled-components';

import PaymentMessage from 'ggApp/shared/common/Payment/PaymentGatewayList/PaymentMessage';

const getColor = ({ mode }) => (mode === 'dark' ? 'white' : 'inherit');

export const StyledPaymentMessage = styled(PaymentMessage)`
    margin-bottom: 15px;
    color: ${({ theme }) => getColor(theme)}
`;
